import { useQuery } from '@tanstack/react-query';
import type { PeriodDto } from '@workforce/shared';
import { api } from './api';

export const useCurrentPeriod = () =>
  useQuery({
    queryKey: ['periods', 'current'],
    queryFn: () => api.get<{ current: PeriodDto; previous: PeriodDto | null }>('/periods/current'),
    staleTime: 10 * 60_000,
  });

export const usePeriods = (enabled = true) =>
  useQuery({ queryKey: ['periods', 'list'], queryFn: () => api.get<PeriodDto[]>('/periods'), enabled });
